import { render, staticRenderFns } from "./Avg.container.vue?vue&type=template&id=3f288883&scoped=true&"
import script from "./Avg.container.vue?vue&type=script&lang=js&"
export * from "./Avg.container.vue?vue&type=script&lang=js&"
import style0 from "./Avg.container.vue?vue&type=style&index=0&id=3f288883&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f288883",
  null
  
)

export default component.exports